var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"menu-button"},[_c('div',{staticClass:"wp-block-diode-blocks-button"},[_c('a',{staticClass:"filled",attrs:{"href":"/auth"}},[_vm._v(" "+_vm._s(_vm.$publicDico.header.button.label)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }